import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = {
    data: Object
  }

  connect() {
    this.chart = new ApexCharts(
      this.element,
      this.options
    )

    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
  }

  get options() {
    return {
      chart: {
        type: "area",
        height: 250,
        toolbar: {
          show: true
        },
        zoom: {
          enabled: true
        }
      },

      dataLabels: {
        enabled: false
      },

      stroke: {
        curve: "smooth"
      },

      xaxis: {
        categories: this.dataValue.categories,
        tickAmount: 10,
      },

      series: this.dataValue.series
    }
  }
}